import * as types from 'constants/actionTypes'

export function changeEditorScene (sceneNum, activeMenuIndex = 0, rawLocation) {
  return {
    type: types.CHANGE_LOCATION,
    sceneNum: Number(sceneNum),
    activeMenuIndex,
    rawLocation
  }
}



// WEBPACK FOOTER //
// ./src/actions/locationAC.js